// @ts-nocheck
/* eslint-disable func-names */
import React, { FunctionComponent, useState, useEffect, useRef } from 'react'
import { useDebouncedCallback } from 'use-debounce'
import { useMediaQuery } from 'react-responsive'

import { Mobile, Desktop } from 'Shared/components/Responsive'

import { SliderProps } from './props'
import {
  SliderContainer,
  StyledSlider,
  InlineStyles,
  InputContainer,
  ValueInput,
  InputOverlay,
} from './styles'

export const Slider: FunctionComponent<SliderProps> = ({
  max = 100,
  min = 0,
  initialValue = 50,
  currency = '$',
  step = 10,
  onChange,
  onDebounce,
  mobileSideContent,
}) => {
  const InputRef: { current: HTMLInputElement } = useRef()

  const [valueInput, setValueInput] = useState(initialValue.toString())
  const [valueSlider, setValueSlider] = useState(initialValue)
  const [isInputFocused, setIsInputFocused] = useState(false)

  const isMobile = useMediaQuery({ maxWidth: 576 })

  const roundValue = (value: number) =>
    Math.round((Math.round(value / step) * step) / 10) * 10

  const roundedMin = roundValue(min)
  const roundedMax = roundValue(max)

  const marks = {
    [roundedMin]: `${currency} ${roundedMin}`,
    [roundedMax]: `${currency} ${roundedMax}`,
  }

  useEffect(() => {
    onChange(initialValue)
  }, [])

  const validateValue = value => {
    const roundedValue = roundValue(value)
    if (roundedValue < roundedMin) {
      setValueInput(roundedMin.toString())
      setValueSlider(roundedMin)
      onChange(roundedMin)
      onDebounce(true)
      return
    }
    if (roundedValue > roundedMax) {
      setValueInput(roundedMax.toString())
      setValueSlider(roundedMax)
      onChange(roundedMax)
      onDebounce(true)
      return
    }
    setValueInput(roundedValue.toString())
    setValueSlider(roundedValue)
    onChange(roundedValue)
    onDebounce(true)
  }

  const [debouncedCallback] = useDebouncedCallback(validateValue, 1500)

  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const substr = e.target.value.substring(
      currency.length + 1,
      e.target.value.length
    )

    if (!/^\d*\.?\d*$/.test(substr)) {
      return
    }

    setValueInput(substr)
    onDebounce(false)
    debouncedCallback(substr)
  }

  const moveSlider = value => {
    const valueRounded = roundValue(value)
    setValueInput(valueRounded.toString())
    setValueSlider(valueRounded)
    onDebounce(false)
    debouncedCallback(valueRounded)
  }

  const onInputFocus = () => {
    setIsInputFocused(true)
    if (InputRef?.current) {
      InputRef?.current.focus()
      InputRef?.current.setSelectionRange(2, 30)
    }
  }

  const onInputBlur = () => {
    setIsInputFocused(false)
  }

  return (
    <SliderContainer>
      <StyledSlider
        min={roundedMin}
        max={roundedMax}
        step={step}
        value={valueSlider}
        currency={currency}
        marks={marks}
        trackStyle={
          isMobile ? InlineStyles.trackStyleMobile : InlineStyles.trackStyle
        }
        // eslint-disable-next-line react/jsx-handler-names
        handleStyle={
          isMobile ? InlineStyles.handleStyleMobile : InlineStyles.handleStyle
        }
        tooltipVisible={false}
        vertical={isMobile}
        onChange={moveSlider}
      />
      <InputContainer>
        <ValueInput
          ref={InputRef}
          value={`${currency} ${valueInput}`}
          onBlur={onInputBlur}
          onChange={onInputChange}
        />
        {!isInputFocused && <InputOverlay onClick={onInputFocus} />}
      </InputContainer>
    </SliderContainer>
  )
}
